import React, {useEffect, useMemo, useState} from 'react';
import {expURL} from "../constants/Feed";
import useFetch, {CachePolicies} from "use-http";

const regexURL = new RegExp(expURL);

const useLinkCover = (link: string) => {
    const [url, setUrl] = useState<string>();
    const [graphDetail, setGraphDetail] = useState<any>();
    const [contentValue, setContentValue] = useState<any>();

    const openGraphAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/crawler/og",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const linkMatchArray: RegExpMatchArray | null = useMemo(() => {
        if (!link) return null;
        return link.match(regexURL)
    }, [link])


    const initDetail = async (url: string) => {
        const res = await handleLinkOpenGraph(url);
        setUrl(url);
        setContentValue(link);
        // let text = extractContent(props?.postContent);
        // setContentValue(text);
    }

    useEffect(() => {
        if (!linkMatchArray) return
        const url = linkMatchArray[0];
        initDetail(url);
    }, [linkMatchArray])

    const handleLinkOpenGraph = async (url: string) => {
        let res;
        try {
            let msgBody = {url: url};
            res = await openGraphAPI.post(msgBody);
            setGraphDetail(res);
        } catch (error) {
            console.warn("Error handleLinkOpenGraph : ", error);
        }
        return res;
    };

    return {
        url,
        linkMatchArray,
        contentValue,
        graphDetail
    }
}

export default useLinkCover;